module.exports = __webpack_public_path__ + "img/horizontal_6_1_7016.b4a438f2.png";